<template>
<div v-show="isShow" class="c-cover">
  <div class="c-coverIn" :class="{'c-coverIn__anim': $store.getters.isShowCoverIn}">
    <div class="c-cover__a">
      <div class="c-cover__aWrap">
        <div class="c-cover__aCover"></div>
        <img class="c-cover__aStart" :src="`${assets_path}img/common/cover-edge.png`" alt="" width="200" height="945" />
      </div>
    </div>
    <div class="c-cover__b">
      <div class="c-cover__bWrap">
        <div class="c-cover__bCover"></div>
        <img class="c-cover__bStart" :src="`${assets_path}img/common/cover-edge.png`" alt="" width="200" height="945" />
      </div>
    </div>
  </div>

  <div class="c-coverOut">
    <transition name="c-cover__a" v-on:after-leave="afterLeave">
    <div class="c-cover__a" v-show="$store.getters.isShowCoverOut">
      <div class="c-cover__aWrap">
        <img class="c-cover__aEnd" :src="`${assets_path}img/common/cover-edge-b.png`" alt="" width="200" height="945" />
        <div class="c-cover__aCover"></div>
      </div>
    </div>
    </transition>
    <transition name="c-cover__b">
    <div class="c-cover__b" v-show="$store.getters.isShowCoverOut">
      <div class="c-cover__bWrap">
        <img class="c-cover__bEnd" :src="`${assets_path}img/common/cover-edge-b.png`" alt="" width="200" height="945" />
        <div class="c-cover__bCover"></div>
      </div>
    </div>
    </transition>
    <transition name="c-cover__logo">
      <div class="c-cover__logo" v-show="$store.getters.isShowCoverOut">
        <img v-show="isFirst && !isTop" :src="`${assets_path}img/common/logo-pics-b.svg`" alt="P.I.C.S" width="230" height="50" />
      </div>
    </transition>
  </div>
</div>
</template>

<script>
  import { breakpoint, assets_path } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';
  import { TweenMax } from 'gsap/all';

  export default {
    components: {

    },
    data() {
      return {
        assets_path: assets_path,
        isTransition: false,
        isShow: true,
        isFirst: false,
        isTop: false,
        nextUrl: ''
      }
    },
    store,
    computed: {

    },
    created() {
      // 初回サイトアクセスとTOPページを判定
      this.$store.commit('setFirst');
      this.$store.commit('setTop');
      this.isFirst = this.$store.getters.getFirst;
      this.isTop = this.$store.getters.getTop;

      // 初回サイトアクセスとTOPページのときの処理は白カバーを表示しない
      if (this.isFirst && this.isTop) {
        this.isShow = false;
        this.$store.commit('setShowCoverOut', false);
      }
    },
    mounted() {
      this.$nextTick(this.start);
    },
    methods: {
      start() {
        this.setting();
      },
      afterEnter() {
        if (this.nextUrl) {
          location.href = this.nextUrl;
        } else {
          location.reload();
        }
      },
      afterLeave() {
        this.isFirst = false;
        this.isShow = false;
      },
      coverIn(url) {
        this.nextUrl = url;
        this.isShow = true;
        this.$store.commit('setShowCoverIn', true);
        this.isTransition = false;
        TweenMax.delayedCall(0.5, this.afterEnter);
      },
      setting() {
        document.addEventListener('click', this.onLink, true);
      },
      onLink(e) {
        //if (this.isTransition) return e.preventDefault();
        this.isTransition = true;

        // aタグを取得する
        let el = e.target;
        while (el && !this.getHref(el)) {
          el = el.parentNode;
        }

        // aタグではない
        const url = this.getHref(el);
        if (!el || !url) {
          this.isTransition = false;
          return false;
        }

        // #なのでtrueならリンク先が現ページと同じ
        if (this.checkMyself(el, url)) {
          this.isTransition = false;
          return false;
        }

        // trueなら外部リンク
        if (this.checkExternal(el, url)) {
          this.isTransition = false;
          return false;
        }

        // URLが全く同じは処理を止める
        if (location.href.replace(/\/$/, '') === el.href) {
          e.preventDefault();
          e.stopPropagation();
          this.isTransition = false;
          return false;
        }

        // 以降はPJAX遷移なのでイベントキャンセル
        e.stopPropagation();
        e.preventDefault();

        console.log(url);

        // ページ遷移発生：カバー演出
        this.coverIn(url);
      },
      getHref(el) {
        if (!el) {
          return undefined;
        }

        if (el.getAttribute && typeof el.getAttribute('xlink:href') === 'string') {
          return el.getAttribute('xlink:href');
        }

        if (typeof el.href === 'string' && el.getAttribute('href')) {
          return el.href;
        }

        return undefined;
      },
      checkMyself(el, url) {
        const base = location.protocol + '//' + location.hostname + location.pathname + location.search;
        // ハッシュ
        if (url.replace(base, '').indexOf('#') === 0) {
          return true;
        }
      },
      checkExternal(el, url) {
        // traget="_blank"
        if (el.target && el.target === '_blank') return true;
        // 拡張子が該当する場合はtarget="_blank"を設定する
        if (/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg|mp4|mp3)/.test(url.toLowerCase())) {
          el.setAttribute('target','_blank');
          return true;
        }
        // wp
        if (url.indexOf('/wp-admin') > -1 || url.indexOf('/wp-login') > -1) return true;

        // protocol違い
        if (location.protocol !== el.protocol || location.hostname !== el.hostname) {
          el.setAttribute('target','_blank');
          return true;
        }
      }
    }
  }
</script>
